import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { LinkedIn } from 'react-linkedin-login-oauth2';
import { userSignUp, loginUser, getIPDetails } from '../../actions/loginActions';
import { getFbCode, getGoogleCode, getTwitterCode } from "../../utils/auth";
import { getInitialRoute, isAppleSafari, bootGuestIntercom, shutdownGuestIntercom } from "../../utils";
import { useCookies, withCookies } from 'react-cookie';
import { addFacebookAccount, addGoogleReviewAccount, getFacebookDetails, googleUserDetails } from "./SocialAuth/connectSocialAcc";
import { HOST_URL, MediaBaseUrl } from "../../actions/api";
import { FontAwesomeIcon } from "../CommonComponents/AssetsHelper";
import GoogleOneTap from "./SocialAuth/GoogleOneTap";


const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

const Login = (props) => {
    const [cookies, setCookie] = useCookies(['member_login']);
    const [passCookes, setPassCookes] = useCookies(['member_password']);
    return <Log {...props} cookies={cookies} setEmail={(email) => setCookie('member_login', email, { path: '/', expires: new Date(Date.now() + (30 * 24 * 60 * 60)) })} setPass={(pass) => setPassCookes('member_password', pass, { path: '/', expires: new Date(Date.now() + (30 * 24 * 60 * 60)) })} />
}
class Log extends Component {
    constructor(props){
        super(props);
        this.state = {
            accountEmail: (props.cookies.member_login && props.cookies.member_password) ? props.cookies.member_login : null,
            accountPassword: (props.cookies.member_login && props.cookies.member_password) ? props.cookies.member_password : null,
            emailError: null,
            passwordError: null,
            loginLoader: false,
            loginSuccessError: null,
            rememberMe: true,
            googleLogin: true
        }
    }
    emailTextChange = event => {
        this.setState({ accountEmail: event.target.value, emailError: null })
    }
    passwordTextChange = event => {
        this.setState({ accountPassword: event.target.value, passwordError: null })
    }
    showPass = event => {
        var x = document.getElementById("AccountPassword");

        var element = document.getElementById("show_password_icon");
        element.classList.toggle("view_pass");

        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    clickOnLogin = async event => {
        const { accountEmail, accountPassword } = this.state
        var self = this;
        const { prefix } = this.props
        this.setState({ loginLoader: true })
        var redirectURL = ""
        if (prefix && String(prefix).includes("widget")) {
            redirectURL = "/widget"
        }
        else if (prefix && String(prefix).includes("display")) {
            redirectURL = "/display"
        }
        if (accountEmail && String(accountEmail).length > 0 && accountPassword && String(accountPassword).length > 0) {
            let data = {};

            await getIPDetails().then((ipResponse) => {
                data = ipResponse.data;
            }).catch(ex => console.log(ex));

            if (this.state.rememberMe === true) {
                this.props.setEmail(accountEmail);
                this.props.setPass(accountPassword);
            }
            this.props.loginUser({
                emailId: accountEmail, password: accountPassword, countryCode: (data && Object.keys(data).length > 0) ? data.country : "US"
            }, redirectURL, self.props.history, self.callBackError);

        }
        else {
            if (!accountEmail || String(accountEmail).length == 0) this.setState({ emailError: true })
            if (!accountPassword || String(accountPassword).length == 0) this.setState({ passwordError: true })
            this.setState({
                loginLoader: false
            })
        }
    }

    onFormSubmit = e => {
        e.preventDefault();
    }
    callBackError = (message) => this.setState({ loginSuccessError: message, loginLoader: false });


    onGSocialLogin = (provider, data) => {
        if (data && Object.keys(data).length > 0) {
            var picture = data.picture ? data.picture : ""
            this.props.userSignUp({ fullName: data.name, emailId: data.email, password: "", activeProduct: `${getInitialRoute() === 'widget' ? '6' : getInitialRoute() === 'socialwalls' ? '4' : '0'}`, createFrom: provider, picture: picture, oauth_uid: data.sub }, this.props.history, this.responseCallback, () => this.setState({ loginLoader: false }))
        }
    }
    onSocialLogin = (provider, data) => {
        if (data && Object.keys(data).length > 0) {
            var picture = `https://graph.facebook.com/${data.id}/picture`;
            this.props.userSignUp({ fullName: data.name, emailId: data.email, password: "", activeProduct: `${getInitialRoute() === 'widget' ? '6' : getInitialRoute() === 'socialwalls' ? '4' : '0'}`, createFrom: provider, picture: picture, oauth_uid: data.id }, this.props.history, this.responseCallback, () => this.setState({ loginLoader: false }))
        }
    }
    onTwiSocialLogin = event => {
        localStorage.setItem("product", `${getInitialRoute() === 'widget' ? '6' : getInitialRoute() === 'socialwalls' ? '4' : '0'}`);
        getTwitterCode();
    }
    responseCallback = (data) => {
        console.log("responseCallback", data)
    }

    onLoginStart = () => {
        console.log('login start');
    }
    onLogoutSuccess = () => {
        console.log('logout success');
    }

    getGoogleAuthCode = () => {
        localStorage.setItem("connectionType", 'googleSignIn');
        getGoogleCode();
    }

    onOneTapSuccess = (provider, data) => {
        if (this.state.loginLoader) return;
        this.setState({ loginLoader: true }, () => this.onGSocialLogin(provider, data));
    }

    getFacebookAuthCode = () => {
        localStorage.setItem("connectionType", 'facebookSignIn');
        getFbCode(3);
    }

    getGoogleUserDetails = (token) => {
        googleUserDetails(token).then(res => this.onGSocialLogin("google", res.data));
    }

    getFacebookUserDetails = (token) => {
        getFacebookDetails({access_token: token}).then(res => this.onSocialLogin('facebook', res.data));
    }

    readAuthenticationCode = (event) => {

        const response = JSON.parse(event.data);
        const { loginLoader } = this.state;
        if (!loginLoader) {
        if (response && Object.keys(response).length > 0) {
            if (response.type == "googleSignIn") {
                this.setState({ loginLoader: true }, () => addGoogleReviewAccount(response.data, (data) => this.getGoogleUserDetails(data.token)));
            }else if(response.type == "facebookSignIn"){
                this.setState({ loginLoader: true }, () => addFacebookAccount(response.data, 3, (data) => this.getFacebookUserDetails(data.token)));
            } else {
                if (response && response.fname && response.email && response.id) {
                    this.setState({ loginLoader: true }, () => this.props.userSignUp({ fullName: `${response.fname} ${response.lname}`, emailId: response.email, password: "", activeProduct: localStorage.getItem("product"), createFrom: "linkedin", picture: response.picture, oauth_uid: response.id }, this.props.history, this.responseCallback, () => this.setState({ loginLoader: false })));
                }

            }
        }
    }
    }

    componentDidMount() {
        bootGuestIntercom();
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    componentWillUnmount() {
        shutdownGuestIntercom();
        channel.removeEventListener("message", this.readAuthenticationCode);
    }


    render() {
        const { prefix } = this.props
        const { accountEmail, accountPassword, emailError, passwordError, loginLoader, loginSuccessError, rememberMe } = this.state;

        return <>
            <GoogleOneTap onSuccess={this.onOneTapSuccess} disabled={loginLoader} context="signin" />

            <div className="loginFormSec formControlMin">
                <div className="loginBlock">
                    <div className="loginInnSec">
                        <div className="loginWithSocials">
                            <div className="loginHead">
                                <h2>Login to Social Walls</h2>
                            </div>

                            <div className="loginSocials">
                                <p className="text-center">Sign in with:</p>
                                <ul className="justify-content-center">
                                    <li>
                                        {/* <SocialGoogleLogin onUpdateData={this.onGSocialLogin} socialLogin={true}> */}
                                        <button className="ladda-button connect-google" id="googleplusSignIn" onClick={() => this.getGoogleAuthCode()}>
                                            <img className="img-responsive me-2" src={`${MediaBaseUrl}icons/social-icons/google.svg`} width={"23"} height={"23"} />
                                            <span>Google</span>
                                        </button>
                                        {/* </SocialGoogleLogin> */}
                                    </li>
                                    <li>
                                        <LinkedIn
                                            clientId="81k7ifnszqybqy"
                                            scope="r_emailaddress,r_liteprofile"
                                            redirectUri={`${HOST_URL}/accounts/linkedinGet`}
                                            onSuccess={(code) => {
                                                console.log(code);
                                            }}
                                            onError={(error) => {
                                                console.log(error);
                                            }}
                                        >
                                            {({ linkedInLogin }) => (
                                                <button className="ladda-button connect-linkedin" id="linkedinSignIn" onClick={() => { localStorage.setItem("product", `${getInitialRoute() === 'widget' ? '6' : getInitialRoute() === 'socialwalls' ? '4' : '0'}`); linkedInLogin() }}>
                                                    <img className="img-responsive me-2" src={`${MediaBaseUrl}icons/social-icons/linkedin.svg`} width={"23"} height={"23"} />
                                                    <span>LinkedIn</span>
                                                </button>
                                            )}
                                        </LinkedIn>
                                    </li>
                                    <li>
                                    <button className="ladda-button  connect-facebook" onClick={this.getFacebookAuthCode}>
                                        <img className="img-responsive me-2" src={`${MediaBaseUrl}icons/social-icons/facebook.svg`} width={"23"} height={"23"} />
                                        <span>Facebook</span>
                                    </button>
                                    </li>
                                </ul>
                                <h2><span>or</span></h2>
                            </div>

                        </div>
                        {loginSuccessError ? <div id="flashFlushMessage" className="alert alert-block alert-danger fade show in flashNotification">
                            <p className="mb-0">{loginSuccessError}	</p>
                        </div> : null}
                        <form method="POST" className="contact_form mainLogin" onSubmit={this.onFormSubmit}>
                            <div className="form-group labelPosition emailSecion">
                                <label htmlFor="AccountEmail">Email</label>
                                <div className="email-input-wrapper">
                                    <input name="data[Account][email]" className={`form-control email-input ${emailError ? `form-error` : ``}`} type="text" value={accountEmail} id="AccountEmail" placeholder="e.g. john@example.com" data-factors-input-id="form-0.field-0" data-gtm-form-interact-field-id="0" onChange={this.emailTextChange} />
                                    <FontAwesomeIcon type={'regular'} icon={'envelope'} iconClass={'email-input-icon'} />
                                </div>
                                {emailError ? <span className="errorMessage">
                                    Email is required.
                                </span> : null}
                            </div>

                            <div className="form-group labelPosition passwordSecion">
                                <label htmlFor="AccountPassword">Password</label>
                                <div className="password-input-wrapper">
                                    <input name="data[Account][password]" autoComplete={'off'} className={`form-control password-input ${passwordError ? `form-error` : ``}`} type="password" id="AccountPassword" placeholder="Enter your password" data-gtm-form-interact-field-id="1" onChange={this.passwordTextChange} value={accountPassword} />
                                    <FontAwesomeIcon type={'regular'} icon={'lock'} iconClass={'password-input-icon'} />
                                    <button id="show_password_icon" type="button" className="password-toggle-icon" onClick={this.showPass} data-factors-form-bind="true" data-factors-click-bind="true">
                                        <FontAwesomeIcon type={'regular'} icon={'eye'} iconClass={'eye-icon'} />
                                        <FontAwesomeIcon type={'regular'} icon={'eye-slash'} iconClass={'eye-slash-icon'} />
                                    </button>
                                </div>
                                {passwordError ? <span className="errorMessage">
                                    Password is required.
                                </span> : null}
                            </div>
                            <div className="form-group remember_check">
                                <label className="loggedinIco checkbox-squre">
                                    <input type="checkbox" name="data[Account][remember]" checked={rememberMe} onChange={() => this.setState({ rememberMe: !rememberMe })} />
                                    <span></span>Remember me
                                </label>
                                <Link className="pull-right" to={`${prefix}accounts/forgotpassword`}>Forgot Password?</Link>
                            </div>
                            <div className="form-group">
                                <button type="submit" className={`btn btn-primary w-100${loginLoader ? ' disabled' : ''}`} onClick={this.clickOnLogin}>
                                    <span className="indicator-label" style={{ display: loginLoader ? 'none' : 'block' }}>Login</span>
                                    <span className="indicator-progress" style={{ display: !loginLoader ? 'none' : 'block' }}> Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </div>
                            <div className="form-group mb-0">
                                <p>Don't have an account? <Link className="btnSignUp" to={`${prefix}accounts/register`}>Sign Up</Link></p>
                                {/* <p>Don't have an account? <Link className="btnSignUp" to={`${prefix}accounts/register`}>Book a Demo</Link></p> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    }
}

const mapDispatchToProps = dispatch => {
    return {
        userSignUp: (data, history, responseCallback, stopLoader) => dispatch(userSignUp(data, history, responseCallback, stopLoader)),
        loginUser: (postbody, history, redirectURL, callback) => dispatch(loginUser(postbody, history, redirectURL, callback))
    }
}
export default connect(null, mapDispatchToProps)(withCookies(Login));